import { get } from '@core/api/baseApi';
import { UsageResponse } from '@core/types';

export const getUsage = async (): Promise<UsageResponse> => {
  const response = await get('/organizations/my-usage');
  
  return response as UsageResponse;
};

